export default __webpack_public_path__ + "static/media/info-icon.f548fc21.svg";